/* eslint-disable @typescript-eslint/no-unused-vars */
import { deliveryColumnStyle, adColumnPreviewStyle, underlineLinkStyle, labelsCellItemStyle, campaignGridBudgetCenterEntryStyle } from '@bingads-webui-campaign-react/common-styles';
import { cellMinWidth, cellMaxWidth } from './variable';

export const columnStyle = ({ palette = {} }) => ({
  '& .flex-column-group': {
    // set a general min-width and max-width. this can be overrided
    '& .ad-type.trigger-popup': {
      borderBottom: '1px dashed #0078D4',
      width: 'fit-content',
      display: 'inline',
      cursor: 'pointer',
    },

    '& .flex-cell': {
      minWidth: cellMinWidth,
      maxWidth: cellMaxWidth,
    },

    '& .flex-cell[data-column=selection]': {
      borderRight: 'none',
      width: 46,
      minWidth: 46,
    },

    '& .flex-cell[data-column=Status]': {
      width: 60,
      minWidth: 60,
      borderRight: 'none',
      '& .grid-edit-icon': {
        display: 'none',
      },

      '& .statuschangehover': {
        display: 'flex',
        justifyContent: 'space-between',
      },

      '& .iconba-ChevronDown': {
        lineHeight: '16px',
        opacity: 0,
        marginLeft: 5,
        fontSize: 11,
        color: palette.themeDark,
      },
    },

    // entity name
    '& .flex-cell[data-column=AdGroup]': {
      width: 300,
      minWidth: 100,
      '&.flex-cell:nth-child(3)': {
        fontSize: '14px',
      },
    },
    '& .flex-cell[data-column=Campaign]': {
      width: 300,
      minWidth: 100,
      '&.flex-cell:nth-child(3)': {
        fontSize: '14px',
      },
      flexWrap: 'wrap',
      '& .experiment-name': {
        flexBasis: '100%',
      },
    },
    '& .flex-cell[data-column=Name]': {
      width: 300,
      minWidth: 100,
      '&.flex-cell:nth-child(3)': {
        fontSize: '14px',
      },
      ...underlineLinkStyle({ palette, elementLocator: 'a.experiment-name' }),
    },

    '& .flex-cell[data-column=Keyword]': {
      width: 300,
      minWidth: 100,
      '&.flex-cell:nth-child(3)': {
        fontSize: '14px',
      },
    },

    '& .flex-cell[data-column=AdPreview]': {
      width: 360,
      minWidth: 260,
      '&.flex-cell:nth-child(3)': {
        fontSize: '14px',
      },
      ...adColumnPreviewStyle(),
    },

    '& .flex-cell[data-column=Delivery]': {
      width: 180,
      ...deliveryColumnStyle(),
    },
    '& .flex-cell[data-column=QualityScore]': {
      width: 180,
      '& .iconba-More': {
        cursor: 'pointer',
      },
    },
    '& .flex-cell[data-column=AdGroupId]': {
      width: 180,
      minWidth: 120,
    },
    '& .flex-cell[data-column=FinalUrlSuffix]': {
      width: 180,
    },
    '& .flex-cell[data-column=AdGroupType]': {
      width: 180,
    },
    '& .flex-cell[data-column=Labels]': {
      width: 180,
      '& .labels-cell-container': {
        ...labelsCellItemStyle(),
      },
    },
    '& .flex-cell[data-column^=AdCustomizerAttributes]': {
      ...deliveryColumnStyle(),
      '& .rsa-ad-customizer-attribute-container': {
        display: 'flex',
        '& .iconba': {
          marginRight: '2px',
        },
      },
    },

    '& .flex-cell[data-column=CallForwarding]': {
      width: 180,
    },

    // The bid strategy name column in campaigns, ad groups and keywords grids
    '& .flex-cell[data-column=BidStrategyName]': {
      width: 240,
    },
    // The bid strategy name column in portfolio bid strategy grid
    '& .flex-cell[data-column=PortfolioGridBidStrategyName]': {
      width: 300,
    },
    '& .flex-cell[data-column=BidStrategyType]': {
      width: 240,
    },
    '& .flex-cell[data-column=Language]': {
      width: 240,
    },

    '& .flex-cell[data-column=StartDate]': {
      width: 120,
      minWidth: 100,
    },
    '& .flex-cell[data-column=EndDate]': {
      width: 120,
      minWidth: 100,
    },


    '& .flex-cell[data-column=TrackingTemplate]': {
      width: 420,
    },

    '& .flex-cell[data-column=CustomParameters]': {
      width: 300,
      minWidth: 100,
    },

    '& .flex-cell[data-column=Budget]': {
      width: 180,
      minWidth: 120,
      '& .iconba-Financial': {
        color: '#0078d4',
      },
      '& .iconba-Financial.disabled': {
        color: palette.neutralTertiary,
      },
      ...campaignGridBudgetCenterEntryStyle({ palette }),
    },

    '& .flex-cell[data-column=DeliveryStatus]': {
      width: 180,
      '& .iconba-Financial': {
        color: '#0078d4',
      },
      '& .iconba-Financial.disabled': {
        color: palette.neutralTertiary,
      },
      ...deliveryColumnStyle(),
    },

    '& .flex-cell[data-column=CampaignId]': {
      width: 180,
      minWidth: 120,
    },

    '& .flex-cell[data-column=CampaignType]': {
      width: 120,
    },

    '& .flex-cell[data-column=DisplayBiddingStrategyType]': {
      width: 180,
    },

    '& .flex-cell[data-column=DisplayBiddingStrategyTargetCpa]': {
      '& .iconba-Financial': {
        color: '#0078d4',
      },
      '& .iconba-Financial.disabled': {
        color: palette.neutralTertiary,
      },
      '& .bidlandscape_icon': {
        paddingLeft: '5px',
      },
    },

    '& .flex-cell[data-column=DisplayBiddingStrategyTargetRoas]': {
      '& .iconba-Financial': {
        color: '#0078d4',
      },
      '& .iconba-Financial.disabled': {
        color: palette.neutralTertiary,
      },
      '& .bidlandscape_icon': {
        paddingLeft: '5px',
      },
    },

    '& .flex-cell[data-column=Languages]': {
      width: 240,
    },

    '& .flex-cell[data-column=MatchType]': {
      width: 180,
    },

    '& .flex-cell[data-column=KeywordId]': {
      width: 240,
    },

    '& .flex-cell[data-column=LandingPage]': {
      width: 300,
      minWidth: 100,
    },

    '& .flex-cell[data-column=Param1]': {
      width: 300,
    },

    '& .flex-cell[data-column=Param2]': {
      width: 300,
    },

    '& .flex-cell[data-column=Param3]': {
      width: 300,
    },

    '& .flex-cell[data-column=FirstPageBidEstimation]': {
      width: 180,
    },

    '& .flex-cell[data-column=MainlineBidEstimation]': {
      width: 180,
    },

    '& .flex-cell[data-column=BestPositionBidEstimation]': {
      width: 180,
    },

    '& .flex-cell[data-column=AdID]': {
      width: 240,
      minWidth: 120,
    },

    '& .flex-cell[data-column=AdType]': {
      width: 240,
      '& div.disabled': {
        color: '#a2a2a2',
      },
    },

    '& .flex-cell[data-column=DevicePreference]': {
      width: 180,
    },

    // performance metrics
    '& .flex-cell[data-column=SearchBid]': {
      width: 120,
    },
    '& .flex-cell[data-column=Medium]': {
      width: 120,
    },
    '& .flex-cell[data-column=Clicks]': {
      width: 120,
    },
    '& .flex-cell[data-column=CTR]': {
      width: 120,
    },
    '& .flex-cell[data-column=AverageCPC]': {
      width: 120,
    },
    '& .flex-cell[data-column=Spend]': {
      width: 120,
    },
    '& .flex-cell[data-column=AveragePosition]': {
      width: 120,
    },
    '& .flex-cell[data-column=AverageCPM]': {
      width: 120,
    },
    '& .flex-cell[data-column=ClickAndPhoneSpend]': {
      width: 120,
    },
    '& .flex-cell[data-column=TopImpressionRate]': {
      width: 120,
    },
    '& .flex-cell[data-column=AbsoluteTopImpressionRate]': {
      width: 120,
    },
    '& .flex-cell[data-column=CPA]': {
      width: 120,
    },
    '& .flex-cell[data-column=Conversions]': {
      width: 120,
    },
    '& .flex-cell[data-column=ConversionRate]': {
      width: 120,
    },
    '& .flex-cell[data-column=AdvertiserReportedRevenue]': {
      width: 120,
    },
    '& .flex-cell[data-column=AllConversionCPA]': {
      width: 120,
    },
    '& .flex-cell[data-column=AllConversions]': {
      width: 120,
    },
    '& .flex-cell[data-column=AllConversionAdvertiserReportedRevenue]': {
      width: 120,
    },
    '& .flex-cell[data-column=AllConversionRevenueOnAdSpend]': {
      width: 120,
    },
    '& .flex-cell[data-column=ViewThroughConversions]': {
      width: 120,
    },
    '& .flex-cell[data-column=AuctionWonPercent]': {
      width: 120,
    },
    '& .flex-cell[data-column=AuctionLostToBudgetPercent]': {
      width: 120,
    },
    '& .flex-cell[data-column=AuctionLostToRankPercent]': {
      width: 120,
    },
    '& .flex-cell[data-column=TopImpressionShareLostToBudget]': {
      width: 120,
    },
    '& .flex-cell[data-column=TopImpressionShareLostToRank]': {
      width: 120,
    },
    '& .flex-cell[data-column=AbsoluteTopImpressionSharePercent]': {
      width: 120,
    },
    '& .flex-cell[data-column=AbsoluteTopImpressionShareLostToBudget]': {
      width: 120,
    },
    '& .flex-cell[data-column=AbsoluteTopImpressionShareLostToRank]': {
      width: 120,
    },
    '& .flex-cell[data-column=AudienceImpressionShare]': {
      width: 120,
    },
    '& .flex-cell[data-column=AudienceImpressionShareLostToBudget]': {
      width: 120,
    },
    '& .flex-cell[data-column=AudienceImpressionShareLostToRank]': {
      width: 120,
    },
    '& .flex-cell[data-column=RelativeCTR]': {
      width: 120,
    },
    '& .flex-cell[data-column=ManualCalls]': {
      width: 120,
    },
    '& .flex-cell[data-column=PTR]': {
      width: 120,
    },
    '& .flex-cell[data-column=Impressions]': {
      width: 120,
    },
    '& .flex-cell[data-column=RevenueOnAdSpend]': {
      width: 120,
    },
    '& .flex-cell[data-column=AllConversionRate]': {
      width: 120,
    },
    '& .flex-cell[data-column=ClickSharePercent]': {
      width: 120,
    },
    '& .flex-cell[data-column=ExactMatchImpressionSharePercent]': {
      width: 120,
    },
    '& .flex-cell[data-column=TopImpressionSharePercent]': {
      width: 120,
    },
    '& .flex-cell[data-column=PhoneImpressions]': {
      width: 120,
    },

    // MMC grids
    '& .flex-cell[data-column=IssueType]': {
      width: 80,
    },
    '& .flex-cell[data-column=ProductIssue]': {
      width: 600,
    },
    '& .flex-cell[data-column=AffectedCountries]': {
      width: 300,
    },
    '& .flex-cell[data-column=AffectedProducts]': {
      width: 150,
    },
    '& .flex-cell[data-column=StoreIssue]': {
      width: 600,
    },
    '& .flex-cell[data-column=FeedIssue]': {
      width: 400,
    },
    '& .flex-cell[data-column=ProductId]': {
      width: 200,
    },
    '& .flex-cell[data-column=ProductTitle]': {
      width: 200,
    },
    '& .flex-cell[data-column=PolicyDetails]': {
      width: 250,
    },
    '& .flex-cell[data-column=PolicyName]': {
      width: 300,
    },
    '& .flex-cell[data-column=PolicyDescriptions]': {
      width: 600,
    },
    '& .flex-cell[data-column=PromotionID]': {
      width: 175,
    },
    '& .flex-cell[data-column=CountryAndLanguage]': {
      width: 200,
    },
    '& .flex-cell[data-column=PromotionStatus]': {
      width: 100,
    },
    '& .flex-cell[data-column=SeasonalityAdjustmentName]': {
      width: 160,
    },
    '& .flex-cell[data-column=Scope]': {
      width: 180,
    },
    '& .flex-cell[data-column=Devices]': {
      width: 220,
    },
    '& .flex-cell[data-column=AdjustmentPercentage]': {
      width: 220,
    },
    '& .flex-cell[data-column=StartTime]': {
      width: 120,
    },
    '& .flex-cell[data-column=EndTime]': {
      width: 120,
    },
    '& .flex-cell[data-column=ConversionsCredit]': {
      '& .status-warning': {
        color: '#D83B01',
        borderBottom: '1px dashed #0078D4',
        cursor: 'pointer',
      },
    },
  },
});
